// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__5JrRf","Logo":"Toolbar_Logo__3upBB","DesktopOnly":"Toolbar_DesktopOnly__h4mDN"};